import { Homepage25Body } from '@/components/astro/new-design-25/homepage-25-body';

export function DefaultLandingPage() {
  return <Homepage25Body />;
}
